var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path2, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path3, _rect20, _rect21, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenTheSet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 686,
    height: 475,
    viewBox: "0 0 686 475",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H685V444.937C685 461.54 671.54 475 654.937 475H0V0Z",
    fill: "#21232B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 56,
    width: 185,
    height: 419,
    fill: "#020203",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 95,
    width: 156,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 71,
    width: 40,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 191,
    width: 149,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 215,
    width: 153,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 239,
    width: 118,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 119,
    width: 115,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 143,
    width: 131,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 167,
    width: 92,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.03
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 685,
    height: 56,
    fill: "#141519"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 120,
    width: 500,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 376,
    width: 501,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185 440H685V445C685 461.569 671.569 475 655 475H185V440Z",
    fill: "white",
    fillOpacity: 0.02
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 184,
    width: 500,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 248,
    width: 500,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 56,
    width: 500,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 312,
    width: 500,
    height: 60,
    fill: "white",
    fillOpacity: 0.02
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 56,
    width: 167,
    height: 60,
    rx: 3,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 519,
    y: 312,
    width: 166,
    height: 60,
    rx: 3,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 120,
    width: 167,
    height: 60,
    rx: 3,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M627 379C627 377.343 628.343 376 630 376H685V436H630C628.343 436 627 434.657 627 433V379Z",
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 361,
    y: 184,
    width: 167,
    height: 60,
    rx: 3,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 248,
    width: 167,
    height: 60,
    rx: 3,
    fill: "#FCFCFC",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 28.0013V23H35.9452L39.3867 28.0012H51.666V33H42.7385L39.2969 28.0013H18Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M273.02 85.5398H272.47V82.9898C272.47 80.7098 271.01 79.0498 269 79.0498C266.99 79.0498 265.53 80.7098 265.53 82.9898V85.5398H264.98C264.44 85.5398 264 85.9798 264 86.5198V91.9698C264 92.5098 264.44 92.9498 264.98 92.9498H273.02C273.56 92.9498 274 92.5098 274 91.9698V86.5198C274 85.9798 273.56 85.5398 273.02 85.5398ZM266.53 82.9898C266.53 81.2598 267.54 80.0498 269 80.0498C270.46 80.0498 271.47 81.2598 271.47 82.9898V85.5398H266.54V82.9898H266.53ZM265 91.9698L264.98 86.5398H273L273.02 91.9498L265 91.9698Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M360.02 149.54H359.47V146.99C359.47 144.71 358.01 143.05 356 143.05C353.99 143.05 352.53 144.71 352.53 146.99V149.54H351.98C351.44 149.54 351 149.98 351 150.52V155.97C351 156.51 351.44 156.95 351.98 156.95H360.02C360.56 156.95 361 156.51 361 155.97V150.52C361 149.98 360.56 149.54 360.02 149.54ZM353.53 146.99C353.53 145.26 354.54 144.05 356 144.05C357.46 144.05 358.47 145.26 358.47 146.99V149.54H353.54V146.99H353.53ZM352 155.97L351.98 150.54H360L360.02 155.95L352 155.97Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M449.02 213.54H448.47V210.99C448.47 208.71 447.01 207.05 445 207.05C442.99 207.05 441.53 208.71 441.53 210.99V213.54H440.98C440.44 213.54 440 213.98 440 214.52V219.97C440 220.51 440.44 220.95 440.98 220.95H449.02C449.56 220.95 450 220.51 450 219.97V214.52C450 213.98 449.56 213.54 449.02 213.54ZM442.53 210.99C442.53 209.26 443.54 208.05 445 208.05C446.46 208.05 447.47 209.26 447.47 210.99V213.54H442.54V210.99H442.53ZM441 219.97L440.98 214.54H449L449.02 219.95L441 219.97Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M538.02 277.54H537.47V274.99C537.47 272.71 536.01 271.05 534 271.05C531.99 271.05 530.53 272.71 530.53 274.99V277.54H529.98C529.44 277.54 529 277.98 529 278.52V283.97C529 284.51 529.44 284.95 529.98 284.95H538.02C538.56 284.95 539 284.51 539 283.97V278.52C539 277.98 538.56 277.54 538.02 277.54ZM531.53 274.99C531.53 273.26 532.54 272.05 534 272.05C535.46 272.05 536.47 273.26 536.47 274.99V277.54H531.54V274.99H531.53ZM530 283.97L529.98 278.54H538L538.02 283.95L530 283.97Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M606.02 341.54H605.47V338.99C605.47 336.71 604.01 335.05 602 335.05C599.99 335.05 598.53 336.71 598.53 338.99V341.54H597.98C597.44 341.54 597 341.98 597 342.52V347.97C597 348.51 597.44 348.95 597.98 348.95H606.02C606.56 348.95 607 348.51 607 347.97V342.52C607 341.98 606.56 341.54 606.02 341.54ZM599.53 338.99C599.53 337.26 600.54 336.05 602 336.05C603.46 336.05 604.47 337.26 604.47 338.99V341.54H599.54V338.99H599.53ZM598 347.97L597.98 342.54H606L606.02 347.95L598 347.97Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M660.02 405.54H659.47V402.99C659.47 400.71 658.01 399.05 656 399.05C653.99 399.05 652.53 400.71 652.53 402.99V405.54H651.98C651.44 405.54 651 405.98 651 406.52V411.97C651 412.51 651.44 412.95 651.98 412.95H660.02C660.56 412.95 661 412.51 661 411.97V406.52C661 405.98 660.56 405.54 660.02 405.54ZM653.53 402.99C653.53 401.26 654.54 400.05 656 400.05C657.46 400.05 658.47 401.26 658.47 402.99V405.54H653.54V402.99H653.53ZM652 411.97L651.98 406.54H660L660.02 411.95L652 411.97Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1430_12144)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 224,
    width: 220,
    height: 44,
    rx: 4,
    fill: "#C1C5DD",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.226 245.354H287.561V242.102C287.561 239.128 285.646 236.95 283 236.95C280.354 236.95 278.439 239.128 278.439 242.102C278.439 242.493 278.748 242.8 279.139 242.8C279.53 242.8 279.839 242.493 279.839 242.102C279.839 240.992 280.164 240.052 280.721 239.391C281.277 238.73 282.066 238.345 283 238.345C283.934 238.345 284.723 238.73 285.279 239.391C285.836 240.052 286.161 240.992 286.161 242.102V245.354H277.774C277.045 245.354 276.45 245.946 276.45 246.673V253.731C276.45 254.458 277.045 255.05 277.774 255.05H288.226C288.955 255.05 289.55 254.458 289.55 253.731V246.673C289.55 245.946 288.955 245.354 288.226 245.354ZM288.176 253.655L277.85 253.681L277.824 246.749H288.15L288.176 253.655Z",
    fill: "#020203",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.755 251.156C305.166 251.156 304.655 251.052 304.221 250.844C303.788 250.627 303.428 250.32 303.142 249.921C302.865 249.522 302.657 249.033 302.518 248.452C302.388 247.871 302.323 247.208 302.323 246.463C302.323 245.726 302.388 245.068 302.518 244.487C302.657 243.898 302.865 243.404 303.142 243.005C303.428 242.606 303.788 242.303 304.221 242.095C304.655 241.878 305.166 241.77 305.755 241.77C306.934 241.77 307.801 242.182 308.355 243.005C308.91 243.828 309.187 244.981 309.187 246.463C309.187 247.945 308.91 249.098 308.355 249.921C307.801 250.744 306.934 251.156 305.755 251.156ZM305.755 249.765C306.059 249.765 306.314 249.709 306.522 249.596C306.73 249.475 306.895 249.306 307.016 249.089C307.146 248.872 307.237 248.608 307.289 248.296C307.35 247.975 307.38 247.62 307.38 247.23V245.683C307.38 244.903 307.259 244.288 307.016 243.837C306.782 243.386 306.362 243.161 305.755 243.161C305.149 243.161 304.724 243.386 304.481 243.837C304.247 244.288 304.13 244.903 304.13 245.683V247.243C304.13 248.023 304.247 248.638 304.481 249.089C304.724 249.54 305.149 249.765 305.755 249.765ZM311.94 251V241.926H315.385C316.269 241.926 316.945 242.177 317.413 242.68C317.881 243.183 318.115 243.867 318.115 244.734C318.115 245.601 317.881 246.285 317.413 246.788C316.945 247.291 316.269 247.542 315.385 247.542H313.643V251H311.94ZM313.643 246.151H315.034C315.494 246.151 315.823 246.06 316.022 245.878C316.222 245.687 316.321 245.388 316.321 244.981V244.487C316.321 244.08 316.222 243.785 316.022 243.603C315.823 243.412 315.494 243.317 315.034 243.317H313.643V246.151ZM321.024 251V241.926H326.757V243.33H322.727V245.696H326.614V247.1H322.727V249.596H326.757V251H321.024ZM331.447 244.487H331.317V251H329.861V241.926H331.954L334.333 248.439H334.463V241.926H335.919V251H333.826L331.447 244.487ZM351.825 243.33V251H350.135V243.33H347.405V241.926H354.555V243.33H351.825ZM361.351 247.1H358.699V251H356.996V241.926H358.699V245.696H361.351V241.926H363.054V251H361.351V247.1ZM366.249 251V241.926H371.982V243.33H367.952V245.696H371.839V247.1H367.952V249.596H371.982V251H366.249ZM387.056 251.156C386.276 251.156 385.608 251.022 385.054 250.753C384.508 250.484 384.061 250.129 383.715 249.687L384.742 248.621C385.08 249.011 385.444 249.301 385.834 249.492C386.232 249.674 386.657 249.765 387.108 249.765C387.628 249.765 388.026 249.648 388.304 249.414C388.581 249.18 388.72 248.842 388.72 248.4C388.72 248.036 388.616 247.763 388.408 247.581C388.2 247.39 387.849 247.256 387.355 247.178L386.393 247.022C385.552 246.875 384.954 246.571 384.599 246.112C384.243 245.644 384.066 245.094 384.066 244.461C384.066 243.594 384.347 242.931 384.911 242.472C385.474 242.004 386.254 241.77 387.251 241.77C387.961 241.77 388.572 241.883 389.084 242.108C389.604 242.333 390.02 242.641 390.332 243.031L389.331 244.097C389.088 243.811 388.798 243.586 388.46 243.421C388.122 243.248 387.723 243.161 387.264 243.161C386.276 243.161 385.782 243.568 385.782 244.383C385.782 244.73 385.886 244.994 386.094 245.176C386.302 245.358 386.657 245.492 387.16 245.579L388.109 245.748C388.897 245.895 389.482 246.186 389.864 246.619C390.245 247.052 390.436 247.607 390.436 248.283C390.436 248.708 390.362 249.098 390.215 249.453C390.067 249.8 389.851 250.103 389.565 250.363C389.279 250.614 388.923 250.809 388.499 250.948C388.083 251.087 387.602 251.156 387.056 251.156ZM393.384 251V241.926H399.117V243.33H395.087V245.696H398.974V247.1H395.087V249.596H399.117V251H393.384ZM406.095 243.33V251H404.405V243.33H401.675V241.926H408.825V243.33H406.095Z",
    fill: "#141519"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1430_12144",
    x: 232,
    y: 224,
    width: 222,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1430_12144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1430_12144",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTheSet);
export default __webpack_public_path__ + "static/media/open-the-set.fe46b8ddcd9f3bff26a777cfa513065b.svg";
export { ForwardRef as ReactComponent };